<syslink-title text="Suppliers"></syslink-title>

<app-supplier-grid
  [permissionKey]="'list'"
  [canUpdate]="false"
  [canDelete]="false"
  (add)="onAddButtonClicked()"
  (rowDoubleClicked)="onRowDoublelick($event)"
></app-supplier-grid>
